import React from 'react';
import { Icon } from '@oscar/theme';
IconMinus.propTypes = {};

interface IIconMinus {
  primary?: boolean;
  iconName:
    | 'process-icon-default'
    | 'process-icon-pending'
    | 'process-icon-done';
}

function IconMinus(props: IIconMinus) {
  return <Icon primary={props.primary} icon={props.iconName} size={20} />;
}

export default IconMinus;
